// Banner promocional do painel lateral da tela de login.
//
// Hoje o conteúdo mora aqui, no código. A intenção é que a GLA passe a editar
// isso no painel admin, como já acontece com as notificações inteligentes —
// por isso o formato abaixo é exatamente o que o endpoint vai devolver, e a
// troca vai ser só o corpo de obterBannerLogin(). Nada mais precisa mudar.
//
// Enquanto for daqui, trocar a promoção exige build e deploy do painel.
//
// Cuidado com o texto: a Meta pode restringir qualquer número que receba
// denúncia, oficial ou não, e o selo de verificação depende da análise dela.
// Por isso o banner fala do que a API Oficial muda de fato (a conexão) e não
// promete número livre de bloqueio nem selo garantido.

export const BANNER_PADRAO = {
  ativo: true,
  // Arte de fundo do painel. Vazio = só o gradiente da marca.
  imagemUrl: '',
  titulo: 'Migre para a API Oficial do WhatsApp',
  subtitulo: 'Conexão oficial da Meta, sem depender do WhatsApp Web nem de QR Code no celular.',
  // Botão opcional: sem endereço, ele não aparece.
  botaoTexto: '',
  botaoUrl: ''
}

// Frases fixas de apoio, mostradas abaixo do banner. Não são promoção: contam
// o que o produto faz para quem está entrando pela primeira vez.
export const DESTAQUES = [
  'Avisos e cobranças no WhatsApp dos seus clientes',
  'Relatório de quem recebeu, leu e respondeu',
  'Conexão por QR Code ou pela API Oficial da Meta'
]

// Fase 2: trocar o corpo por uma chamada ao endpoint público do master,
// caindo no BANNER_PADRAO quando a requisição falhar — a tela de login nunca
// pode quebrar por causa de um banner.
export async function obterBannerLogin() {
  return BANNER_PADRAO
}
